module.exports = __webpack_public_path__ + "static/img/image_solutions_intellgent_06.a9455d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/solution/image_solutions_intellgent_06.png
// module id = xzeP
// module chunks = 10